import { render } from "./DriverGuideForm.vue?vue&type=template&id=fd6c623c"
import script from "./DriverGuideForm.vue?vue&type=script&lang=js"
export * from "./DriverGuideForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__